// SingleUserTrips.js

import { getFirestore, collection, addDoc, getDocs, serverTimestamp } from 'firebase/firestore';
import { Timestamp } from 'firebase/firestore';

/**
 * מחשב גיל לפי תאריך לידה
 */
function calculateAge(dateString) {
    if (!dateString) return '';
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}


export const saveSingleUserTrip = async (userProfile, preferences) => {
    if (!userProfile) throw new Error("User profile is undefined");


    const db = getFirestore();
    const uid = localStorage.getItem("uid");
    const age = calculateAge(userProfile.birthDate || '');

    const tripData = {
        ...preferences,
        style: preferences.style ? (Array.isArray(preferences.style) ? preferences.style : [preferences.style]) : [],
        region: preferences.region ? (Array.isArray(preferences.region) ? preferences.region : [preferences.region]) : [],
        difficulty: preferences.difficulty ? (Array.isArray(preferences.difficulty) ? preferences.difficulty : [preferences.difficulty]) : [],
        duration: preferences.duration ? (Array.isArray(preferences.duration) ? preferences.duration : [preferences.duration]) : [],
        groupSize: preferences.groupSize ? (Array.isArray(preferences.groupSize) ? preferences.groupSize : [preferences.groupSize]) : [],
        participants: [uid],
        dates: preferences.dates?.map(date => Timestamp.fromDate(new Date(date))) || [],
        createdAt: serverTimestamp(),
        createdBy: uid,
        eventOwner: uid,
        userInfo: {
            name: userProfile.title || '',
            age: age || '',
            image: userProfile.image || '',
            coverImage: userProfile.coverImage || '',
            location: userProfile.location || '',
            interests: userProfile.interests || '',
            about: userProfile.about || '',
        },
        isGroupTrip: false,
    };


    try {
        const docRef = await addDoc(collection(db, 'SingleUserTrips'), tripData);
        console.log("Trip created with ID:", docRef.id);
        return docRef.id;
    } catch (error) {
        console.error("Error creating trip:", error);
        throw error;
    }
};

export const fetchSingleUserTrips = async (querySnapshot, predicate) => {
    const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    console.log("📦 All SingleUserTrips from Firestore:", data);
    return data.filter(predicate);
};

